import Vue from 'vue'

import App from './App.vue'
import registerServiceWorker from './registerServiceWorker.js'

import store from './store.js'
import router from './router.js'
import initApp from './lib/lifecycle.js'

import './config.js'
import vuetify from './plugins/vuetify.js'

Vue.config.productionTip = false

Vue.filter('truncate', (value, max = 25) => {
  if (!value) return ''
  value = value.toString()
  if (value.length > max) {
    return value + '…'
  }
  return value
})

Vue.filter('date', (value, options = { year: 'numeric', month: 'numeric', day: 'numeric' }) => {
  if (!value) return ''

  const date = new Date(value)

  return date.toLocaleDateString('en-GB', options)
})

router.beforeEach((to, from, next) => {
  initApp(store, next)
})

registerServiceWorker({
  onUpdateReady: () => {
    store.commit('updateReady', true)
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
